import config from '../../config';
import css from './errorPage.module.scss';

const ErrorPageUnderlineLink = ({ children }) => (
  <>
    <a
      role="button"
      tabIndex="0"
      data-testid="linkToOrigin"
      target="_self"
      href={config.secureOrigin}
      className={css.underlineLink}
    >
      <span>
        {children}
        <i />
      </span>
    </a>
  </>
);

export default ErrorPageUnderlineLink;
